import { usePlanMainTarget } from "@/components/features/items/edit/plan/_shared/ui/components/main-target/hooks";

import { useProductDayTripPlanFormModelContext } from "../../../../context";

export const useDayTripPlanMainTarget = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();

	const { mainTarget } = viewModel;

	return usePlanMainTarget({ mainTarget, onSetViewModel });
};
